import { parseAsString, useQueryStates } from 'nuqs'
import { format } from 'date-fns'

export function useDateFilter() {
	const today = new Date()
	const todayFormatted = format(today, 'yyyy-MM-dd')

	const [queryState, setQueryState] = useQueryStates({
		startDate: parseAsString.withDefault(todayFormatted),
		endDate: parseAsString.withDefault(todayFormatted),
	})

	return {
		dateFilter: {
			startDate: queryState.startDate || undefined,
			endDate: queryState.endDate || undefined,
		},
		setDateFilter: (values: {
			startDate: string | null | undefined
			endDate: string | null | undefined
		}) => {
			setQueryState({
				startDate: values.startDate || '', // Convert null/undefined to empty string
				endDate: values.endDate || '', // Convert null/undefined to empty string
			})
		},
	}
}
